export enum paymentMode
{
   CreditCard,
   Cash,
   StripeTerminal
}